import { usePostApply } from '@components/hooks/PostApplyProvider/index.client'
import Button, { buttonClassNames } from '@components/primitives/Button'
import { IconPrefix } from '@components/primitives/Icon/IconPrefix'
import { classMerge } from '@components/utilities/classMerge'
import { faArrowRight } from '@fortawesome/pro-regular-svg-icons/faArrowRight'
import { faSpinnerThird } from '@fortawesome/pro-regular-svg-icons/faSpinnerThird'
import PatientRoutes from '@lib/routes/PatientRoutes'
import { trackEvent } from '@lib/tracking'
import { TrackingEvents } from '@lib/tracking/TrackingEvents'
import { TrackingSources } from '@lib/tracking/TrackingSources'
import type { ApplySuccessPageProps } from 'app/p/apply-success/[token]/[step]/page'
import { useRouter } from 'next/navigation'

export default function ShareYourStoryButtonGroup(
  props: ApplySuccessPageProps,
) {
  const { advanceToNextStep, isLoading, persistWhyApplyToTrial } =
    usePostApply()
  const router = useRouter()

  const goToNextScreen = () => {
    advanceToNextStep()
    router.push(PatientRoutes.applyPackage(props.idToken))
  }

  const icon = isLoading ? faSpinnerThird : faArrowRight
  const animateClassName = isLoading
    ? 'motion-safe:animate-spin'
    : 'motion-safe:animate-none'
  return (
    <div className='z-10 mx-8 flex w-full flex-row justify-end gap-2'>
      <Button
        className={classMerge(
          buttonClassNames.legacy.outline.white,
          'pointer-events-auto w-full rounded-full md:w-48',
        )}
        disabled={isLoading}
        onClick={goToNextScreen}
        value='Skip'
      />
      <Button
        className={classMerge(
          buttonClassNames.legacy.fill.black,
          'pointer-events-auto w-full rounded-full md:w-48',
        )}
        disabled={isLoading}
        onClick={async () => {
          await persistWhyApplyToTrial(true)
          trackEvent(
            TrackingEvents.POST_TRIAL_APPLY_SHARE_STORY_CONSENT_SUBMIT_BUTTON_CLICKED,
            {
              source: TrackingSources.PATIENT_POST_APPLY,
              trialApplicationIdToken: props.idToken,
            },
          )
          goToNextScreen()
        }}
        value={
          <IconPrefix className={animateClassName} icon={icon}>
            <span className='ml-2'>Sure</span>
          </IconPrefix>
        }
      />
    </div>
  )
}
